import memoizeOne from "memoize-one";
import { ALLOCATION_BAG_ID, CollectionKeys, ITEMS_ID, SizeAllocationType } from "constants/product-collection";
import { IStore } from "reducers";
import { getHEAD, getMutate, getPoiObjectId, getSnapshot } from "reducers/selectors/mutate";

export const ITEMS_OBJECT_ID_PATH = ["items", "ref", "object_id"];
export const DEFAULT_ITEM_OBJECT_ID_PATH = ["default_item", "ref", "object_id"];
export const POI_TAGS_OBJECT_ID_PATH = ["collection_poi_tags_object_id", "ref", "object_id"];
export const EXPORT_VALIDATION_LOG_OBJECT_ID_PATH = ["export_validation_status_object_id", "ref", "object_id"];

const getCollectionEquality = (
    newArgs: Parameters<typeof getCollectionRaw>,
    oldArgs: Parameters<typeof getCollectionRaw>,
) => {
    const newCollectionHEAD = getHEAD(...newArgs);
    const oldCollectionHEAD = getHEAD(...oldArgs);

    const newCollectionId = `${newArgs[1]}${newArgs[2] ? "-" + newArgs[2] : ""}`;
    const oldCollectionId = `${oldArgs[1]}${oldArgs[2] ? "-" + oldArgs[2] : ""}`;

    return newCollectionId === oldCollectionId && newCollectionHEAD?.revision === oldCollectionHEAD?.revision;
};
const getCollectionRaw = (state: IStore, collectionId: string, poi?: string) => {
    return getSnapshot(state, collectionId, poi);
};
export const getCollection = memoizeOne(getCollectionRaw, getCollectionEquality);

export const getItemsRevision = (state, poi?: string) =>
    getMutate(state).committedHEADs.get(getPoiObjectId(ITEMS_ID, poi))?.revision;

export const getCollectionItems = (state: IStore, collectionId: string, poi?: string) => {
    const collectionSnapshot = getSnapshot(state, collectionId, poi);
    const itemsId = collectionSnapshot?.getIn(ITEMS_OBJECT_ID_PATH);

    return getSnapshot(state, itemsId, poi);
};

export const getCollectionTags = (state, collectionId: string) => {
    const collectionSnapshot = getSnapshot(state, collectionId);
    const poiTagsId = collectionSnapshot?.getIn(POI_TAGS_OBJECT_ID_PATH);

    return getSnapshot(state, poiTagsId);
};

export const getCollectionItemDisplayProperty = memoizeOne((state: IStore, collectionId: string, poi?: string) => {
    const collection = getCollection(state, collectionId, poi);
    const itemDisplayProperty = collection ? collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS) : undefined;
    return itemDisplayProperty;
});

export const getCollectionDefaultItem = (state, collectionId: string, poi?: string) => {
    const collectionSnapshot = getSnapshot(state, collectionId, poi);
    const defaultItemId = collectionSnapshot?.getIn(DEFAULT_ITEM_OBJECT_ID_PATH);

    return getSnapshot(state, defaultItemId);
};

export const getCollectionErrorLog = (state, collectionId?: string, poi?: string) => {
    const collectionSnapshot = getSnapshot(state, collectionId, poi);
    const errorLogItemId = collectionSnapshot?.getIn(EXPORT_VALIDATION_LOG_OBJECT_ID_PATH);
    return getSnapshot(state, errorLogItemId);
};

export const getCollectionSizePacksByBrandId = (state, brandId: string) => {
    return state.collection.sizePacks[brandId];
};

export const getCollectionSizeAllocationType = (state, collectionId): SizeAllocationType | undefined => {
    const collection = getCollectionRaw(state, collectionId);
    return collection ? collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.SIZE_ALLOCATION_TYPE) : undefined;
};

export const getCollectionAllocationBag = (state, _collectionId: string, poi?: string) => {
    return getSnapshot(state, ALLOCATION_BAG_ID, poi);
};
